import { makeStaticStyles } from '@griffel/react';
import type { ReactNode } from 'react';
import { IconContext } from './design/icons';

/**
 * Seitenfläche und Icon-Standard (nach `AxisProvider`). Es gibt **kein Fluent-Theme**: Farben, Schrift und Radien
 * kommen aus den Tokens in `design/tokens.css`, die `app` einmal einbindet (`import '@ksb/ui/design.css'`).
 *
 * `overflowX: 'hidden'` nur auf `html`, nicht zusätzlich auf `body` — sonst werden beide zu Scroll-Containern und
 * `position: sticky` (Kopfzeile) bindet sich an das bewegungslose `body` (Befund aus Axis).
 */
const useStaticStyles = makeStaticStyles({
  html: {
    minHeight: '100%',
    backgroundColor: 'var(--color-surface-light-brand)',
    overflowX: 'hidden',
    margin: 0,
  },
  body: {
    minHeight: '100%',
    backgroundColor: 'var(--color-surface-light-brand)',
    color: 'var(--color-text-primary)',
    fontFamily: 'var(--font-body)',
    fontSize: '16px',
    lineHeight: '24px',
    margin: 0,
  },
  '#root': {
    minHeight: '100vh',
  },
});

export function KsbProvider({ children }: { children: ReactNode }) {
  useStaticStyles();
  // Phosphor-Icons: durchgehend Light, 1em groß (erbt die Schriftgröße), wenn eine Stelle nichts anderes sagt.
  return (
    <IconContext.Provider value={{ weight: 'light', size: '1em' }}>{children}</IconContext.Provider>
  );
}
